import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';

/* -------- packages -------- */
import * as Yup from "yup";
import {  Card, CardBody, Container, Form, FormFeedback, Input, Modal, ModalBody, ModalHeader, Row} from "reactstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { duplicateConfigurationRequest } from "../../../store/actions";
/* -------- ------- -------- */

export default function DuplicateModal ({ show, setModalOpen, config }){
    const { t } = useTranslation();
    const parameters = useSelector(state => state.Parameters);
    const dispatch = useDispatch();

    const duplicateForm = useFormik({
      enableReinitialize: true,
    
      initialValues: {
        //projectName: editProject ? editProject.lib : '',
      },
      validationSchema: Yup.object({
        lib: Yup.string()
        .required( t('REQUIRED'))
      }),
      onSubmit: (values) => {
        dispatch(duplicateConfigurationRequest(config.id, values));
        setModalOpen(false)
      },
    });

    return (
      <Modal isOpen={show} toggle={() => setModalOpen(true)} centered={true} size={'xl'} scrollable={true} className="newProjectModal">
        <div className="modal-content">
        <ModalHeader toggle={() => setModalOpen(false)}>{`${t('duplicateConfig')}`}</ModalHeader>
          <ModalBody className="text-center">
            <Container>
              <Card className="">
                <CardBody className="newProjectBody">
                  <Row>
                  <p className="text-muted font-size-16 mb-4">{t('duplicateNewConfig')}</p>
        
                  <div className="d-flex justify-content-center mb-0">

                    <Form onSubmit={duplicateForm.handleSubmit} className="w-100 d-flex flex-column align-items-center justify-content-center">
                      <div className="row inputContainer">
                          <Input
                          name="lib"
                          className="input-projectName"
                          autoComplete="on"
                          placeholder={parameters.appName}
                          value={duplicateForm.values.lib || ""}
                          type="text"
                          onChange={duplicateForm.handleChange}
                          onBlur={duplicateForm.handleBlur}
                          invalid={duplicateForm.touched.lib && duplicateForm.errors.lib ? true : false}
                          />
                          <FormFeedback className={'d-block text-info'}>
                            {t('duplicateNameCharacter')}
                          </FormFeedback>
                        {duplicateForm.touched.lib && duplicateForm.errors.lib ? 
                          (
                            <FormFeedback type="invalid" id="duplicateFormFeedbackduplicateName" data-cy="signin-duplicateNameError">
                            {duplicateForm.errors.lib}
                          </FormFeedback>
                          ) 
                          : null
                        }
                      </div>
                    </Form> 
                  </div>
                  </Row>
                  <div className="row">
                      <div className="card-footer">
                        <button type="submit" onClick={duplicateForm.handleSubmit} className="btn btn-primary">{t('validate')}</button>
                        <button type="button" className="btn btn-secondary" onClick={() => {setModalOpen(false)}}>{t('close')}</button>
                      </div>
                  </div>
                  </CardBody>
                </Card>
            </Container>
          </ModalBody>
        </div>
      </Modal>
    );
};